import React, { Component } from "react";
import { languages } from "../../constants/languages";
import EditSportParkDialog from "../../components/schedule/EditSportParkDialog";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import { withStyles } from "@material-ui/core/styles";
// import ExpansionPanel from "@material-ui/core/ExpansionPanel";
// import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
// import Typography from "@material-ui/core/Typography";
import CreateIcon from "@material-ui/icons/Create";
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import Avatar from "@material-ui/core/Avatar";
import IconButton from "@material-ui/core/IconButton";
import { getUploadErrorMessage } from "../../util/uploadErrors";

const StyledAvatar = withStyles({
  img: {
    height: "unset",
    borderRadius: 4,
  },
})(Avatar);

// Create a custom CardHeader with fixed title styles
const CustomCardHeader = withStyles({
  title: {
    width: "100%",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    flex: 1,
  },

  content: {
    overflow: "hidden",
  },
  action: {
    marginTop: 0,
    marginRight: 0,
    alignSelf: "center",
  },
  root: {
    padding: "5px 15px",
    display: "flex",
  },
})(CardHeader);

class EditSportParkContainer extends Component {
  state = {
    open: false,
    name: "",
    secondaryName: "",
    id: null,
    placeId: null,
    reference: null,
    errorMessage: "",

    sponsorName: "",
    sponsorLogoURL: "",
    isUploading: false,
    errorMessageSponsor: "",
    showSponsor: false,
    newSponsorLogo: false,
  };

  handleShowSponsorChange = (event, checked) => {
    let newState = {};
    newState[event.target.name] = checked;
    this.setState(newState);
  };

  toggleDialog = (e) => {
    // e.stopPropagation();
    this.setState({ open: !this.state.open });
  };

  UNSAFE_componentWillMount = () => {
    const sportPark = this.props.sportPark;
    if (sportPark) {
      this.updateState(sportPark);
    }
  };

  // UNSAFE_componentWillReceiveProps = nextProps => {
  //   const sportPark = nextProps.sportPark;
  //   if (sportPark) {
  //     this.updateState(sportPark);
  //   }
  // };

  updateState = (sportPark) => {
    this.setState({
      name: sportPark.name,
      id: sportPark.gId || null,
      placeId: sportPark.placeId || null,
      reference: sportPark.reference || null,
      sponsorName: sportPark.sponsorName || "",
      sponsorLogoURL: sportPark.sponsorLogoURL || "",
      showSponsor: sportPark.showSponsor || false,
    });
  };

  handleNameChange = (e) => {
    this.setState({
      name: e.target.value,
      id: null,
      placeId: null,
      reference: null,
    });
  };

  setName = (newValue) => {
    let value = newValue || {};
    let name =
      (value.structured_formatting || {}).main_text || value.description || "";
    let secondaryName =
      (value.structured_formatting || {}).secondary_text ||
      value.description ||
      "";
    let id = value.id || null;
    let placeId = value.place_id || null;
    let reference = value.reference || null;
    this.setState({
      name: name,
      secondaryName: secondaryName,
      id: id,
      placeId: placeId,
      reference: reference,
    });
  };

  handleSubmit = (e) => {
    e.preventDefault();
    this.toggleDialog(e);
    const tournamentRef = window.firebase
      .firestore()
      .collection("tournaments")
      .doc(this.props.tournament[".key"]);

    let name = this.state.name;
    let sportPark = {
      name: name,
      secondaryName: this.state.secondaryName,
      sponsorName: this.state.sponsorName,
      sponsorLogoURL: this.state.sponsorLogoURL,
      showSponsor: this.state.showSponsor,
    };
    if (this.state.id) {
      sportPark["gId"] = this.state.id;
    }
    if (this.state.placeId) {
      sportPark["placeId"] = this.state.placeId;
    }
    if (this.state.reference) {
      sportPark["reference"] = this.state.reference;
    }
    let sportParkId = "0";
    if (this.props.sportParks.length > 0) {
      sportParkId = (
        Number(
          this.props.sportParks.sort((a, b) => {
            if (Number(a.id) > Number(b.id)) {
              return 1;
            } else if (Number(a.id) < Number(b.id)) {
              return -1;
            } else {
              return 0;
            }
          })[this.props.sportParks.length - 1].id
        ) + 1
      ).toString();
    }
    let sportParkDoc = tournamentRef.collection("sportParks").doc(sportParkId);
    if (this.props.sportPark) {
      sportParkDoc = tournamentRef
        .collection("sportParks")
        .doc(this.props.sportPark.id);
      sportParkId = this.props.sportPark.id;
      if (this.props.sportPark.num !== undefined) {
        sportPark["num"] = this.props.sportPark.num;
      }
    }
    sportParkDoc.set(sportPark).then(() => {
      if (this.state.sponsorLogoURL && this.state.newSponsorLogo) {
        var httpsReference = window.firebase
          .app()
          .storage("gs://tournament-uploads/")
          .refFromURL(this.state.sponsorLogoURL);
        httpsReference
          .updateMetadata({
            customMetadata: {
              sponsorType: "sportParks",
              tournamentId: this.props.tournament[".key"],
              elementId: sportParkId,
            },
          })
          .catch(function (error) {
            // Uh-oh, an error occurred!
            console.log(error.message);
          });
      }
      if (!this.props.sportPark) {
        this.setState({
          name: "",
          secondaryName: "",
          sponsorName: "",
          sponsorLogoURL: "",
          showSponsor: false,
        });
      }
    });
  };

  handleDelete = (e) => {
    e.preventDefault();
    if (
      Object.keys(this.props.tournament.fields || {}).filter(
        (key) =>
          this.props.tournament.fields[key].sportPark ===
          this.props.sportPark.id
      ).length > 0
    ) {
      this.setState({ errorMessage: languages.schedule.cannotDeleteSportPark });
    } else {
      this.toggleDialog(e);

      if (this.props.sportPark.id === this.props.selectedSportPark) {
        this.props.selectSportPark("0");
      }

      const tournamentRef = window.firebase
        .firestore()
        .collection("tournaments")
        .doc(this.props.tournament[".key"]);
      tournamentRef
        .collection("sportParks")
        .doc(this.props.sportPark.id)
        .delete();
    }
  };

  handleDeleteSponsor = () => {
    let toUpdate = { sponsorLogoURL: "", newSponsorLogo: false };
    this.setState(toUpdate);
    // let urlToDelete = this.state.sponsorLogoURL;

    // window.firebase
    //   .firestore()
    //   .collection("tournaments")
    //   .doc(this.props.tournament[".key"])
    //   .collection("sportParks")
    //   .doc(this.props.sportPark.id)
    //   .update(toUpdate);

    // var httpsReference = window.firebase
    //   .app()
    //   .storage("gs://tournament-uploads/")
    //   .refFromURL(urlToDelete);
    // httpsReference.delete().catch(function (error) {
    //   // Uh-oh, an error occurred!
    //   console.log(error.message);
    // });
  };

  getStorageRef = () => {
    return window.firebase
      .app()
      .storage("gs://tournament-uploads/")
      .ref(
        "sponsors/" + this.props.user.uid + "/" + this.props.tournament[".key"]
      );
  };

  handleUploadStart = () => {
    this.setState({
      isUploading: true,
      errorMessageSponsor: "",
    });
  };

  handleProgress = (progress) => {
    this.setState({ progress });
  };

  handleUploadError = (error) => {
    this.setState({ isUploading: false });
    let toUpdate = { errorMessageSponsor: getUploadErrorMessage(error, 1) };
    this.setState(toUpdate);
  };

  handleUploadSuccess = (filename) => {
    this.setState({ isUploading: false });
    const storageRef = this.getStorageRef();
    storageRef
      .child(filename)
      .getDownloadURL()
      .then((url) => {
        let toUpdate = { sponsorLogoURL: url, newSponsorLogo: true };
        this.setState(toUpdate);
        // window.firebase
        //   .firestore()
        //   .collection("tournaments")
        //   .doc(this.props.tournament[".key"])
        //   .collection("sportParks")
        //   .doc(this.props.sportPark.id)
        //   .update(toUpdate);
      });
  };

  handleSponsorNameChange = (e) => {
    let toUpdate = {};
    toUpdate[e.target.name] = e.target.value;
    this.setState(toUpdate);
  };

  render() {
    let allowedToUpload = false;
    if (
      (this.props.tournamentStatus || {}).status === 1 ||
      (this.props.tournamentStatus || {}).status === 2 ||
      (this.props.tournamentStatus || {}).status === 3 ||
      (this.props.userStatus || {}).status === 1 ||
      (this.props.userStatus || {}).status === 2 ||
      (this.props.userStatus || {}).status === 3
    ) {
      allowedToUpload = true;
    }

    return (
      <div>
        {this.props.sportPark ? (
          this.props.new ? (
            <TextField
              style={{ marginTop: 10, marginBottom: 5 }}
              onClick={this.toggleDialog}
              value={this.props.sportPark.name}
              fullWidth
              label={languages.schedule.sportPark + " " + this.props.num}
              disabled={this.props.isDisabled}
            />
          ) : (
            // <ExpansionPanel
            //   expanded={false}
            //   style={{
            //     width: "100%",
            //     margin: "1px 0px 1px 0px",
            //   }}
            // >
            //   <ExpansionPanelSummary
            //     IconButtonProps={{ onClick: this.toggleDialog }}
            //     expandIcon={this.props.isDisabled ? null : <CreateIcon />}
            //     style={{ cursor: "inherit" }}
            //   >
            //     {this.state.sponsorLogoURL && (
            //       <img
            //         style={{ height: 20 }}
            //         src={this.state.sponsorLogoURL}
            //         alt=""
            //       />
            //     )}
            //     <Typography
            //       variant="body2"
            //       style={{
            //         flexBasis: "33.33%",
            //         flexShrink: 0,
            //         color: "rgba(0, 0, 0, 0.54)",
            //       }}
            //     >
            //       {languages.schedule.sportPark + " " + this.props.num}
            //     </Typography>
            //     <Typography variant="body2">
            //       {this.props.sportPark.name}
            //     </Typography>
            //   </ExpansionPanelSummary>
            // </ExpansionPanel>

            <Card style={{ marginBottom: 1 }}>
              <CustomCardHeader
                avatar={
                  <StyledAvatar
                    variant="rounded"
                    style={{
                      fontWeight: 500,
                    }}
                    aria-label="location-number"
                    src={
                      this.props.sportPark.sponsorLogoURL &&
                      this.props.sportPark.showSponsor
                        ? this.props.sportPark.sponsorLogoURL
                        : ""
                    }
                  >
                    {this.props.sportPark.sponsorLogoURL &&
                    this.props.sportPark.showSponsor
                      ? ""
                      : this.props.num}
                  </StyledAvatar>
                }
                action={
                  <IconButton
                    aria-label="edit-location"
                    onClick={this.toggleDialog}
                    disabled={this.props.isDisabled}
                  >
                    <CreateIcon />
                  </IconButton>
                }
                title={
                  this.props.sportPark.name +
                  (this.props.sportPark.sponsorName &&
                  this.props.sportPark.showSponsor
                    ? " - " + this.props.sportPark.sponsorName
                    : "")
                }
              />
            </Card>
          )
        ) : this.props.new ? (
          <Button
            style={{ marginTop: 10 }}
            variant="outlined"
            color="default"
            onClick={this.toggleDialog}
            disabled={this.props.isDisabled}
          >
            {languages.createTournament.addLocation}
          </Button>
        ) : (
          <Button
            style={{ height: 48 }}
            variant="outlined"
            color="default"
            onClick={this.toggleDialog}
            fullWidth
            disabled={this.props.isDisabled}
          >
            {languages.schedule.addSportPark}
          </Button>
        )}
        <EditSportParkDialog
          name={this.state.name}
          open={this.state.open}
          sportPark={this.props.sportPark}
          toggleDialog={this.toggleDialog}
          handleChange={this.handleNameChange}
          handleSubmit={this.handleSubmit}
          handleDelete={this.handleDelete}
          errorMessage={this.state.errorMessage}
          errorMessageSponsor={this.state.errorMessageSponsor}
          setName={this.setName}
          // sponsor
          sponsorName={this.state.sponsorName}
          sponsorLogoURL={this.state.sponsorLogoURL}
          sponsorStorageRef={this.getStorageRef()}
          handleDeleteSponsor={this.handleDeleteSponsor}
          handleUploadStart={this.handleUploadStart}
          handleProgress={this.handleProgress}
          handleUploadError={this.handleUploadError}
          handleUploadSuccess={this.handleUploadSuccess}
          allowedToUpload={allowedToUpload}
          new={this.props.new}
          handleSponsorNameChange={this.handleSponsorNameChange}
          handleShowSponsorChange={this.handleShowSponsorChange}
          showSponsor={this.state.showSponsor}
          toggleUpgradeDialog={this.props.toggleUpgradeDialog}
          isUploadingSponsor={this.state.isUploading}
        />
      </div>
    );
  }
}

export default EditSportParkContainer;
